import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function MagicConsume() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next");
    if (!token) { setStatus("error"); setError("no token"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/consume", { token });
        localStorage.setItem("sd_token", data.token);
        await refresh();
        setStatus("ok");
        toast.success("signed in.");
        const destination = next && next.startsWith("/") ? next : "/continue";
        setTimeout(() => nav(destination), 800);
      } catch (e) {
        setStatus("error");
        setError(e?.response?.data?.detail || "could not verify link");
      }
    })();
  }, [params, nav, refresh]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="magic-consume">
      <div className="text-center max-w-md">
        <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: "var(--gold)" }}>
          {status === "ok" ? "welcome back" : status === "error" ? "sign-in link" : "verifying"}
        </p>
        <h1 className="font-serif text-4xl mb-4" style={{ color: "var(--ink)" }}>
          {status === "ok" ? "you're in." : status === "error" ? error : "one moment..."}
        </h1>
        {status === "error" && (
          <p style={{ color: "var(--ink-soft)" }}>
            request a fresh link on the <a href="/login" className="underline">sign-in page</a>.
          </p>
        )}
      </div>
    </div>
  );
}
